<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">File Settings</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="value"
                    :items="items"
                    solo
                    label="Type"
                    class="p-1em pt-0"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="btn btn-primary"
              rounded
              @click="dialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row style="justify-content: center">
        <v-btn
          class="mx-2"
          fab
          small
          light
          color="btn btn-primary"
          @click.stop="dialog = true"
        >
          <i class="fa fa-cog"/>
        </v-btn>
      </v-row>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'File',
  props: ['item'],
  data() {
    return {
      dialog: false,
      defaultValue: 'image',
      value: '',
      items: [
        {value: 'image', text: 'Image(png,jpg)'},
        {value: 'document', text: 'Document(pdf,doc,xls)'},
        {value: 'archive', text: 'Archive(zip,rar)'},
      ],
    }
  },
  watch: {
    value() {
      this.setItemValue()
    }
  },
  mounted() {
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      if (!this.value && !this.item.value){
        this.value = this.defaultValue
        return
      }

      this.setItemValue(this.item.value)
    },
    setItemValue(value) {
      if(value){
        this.$set(this.item, 'value', value)
        return
      }
      this.$set(this.item, 'value', this.value)
    },
  }
}
</script>
